import { NestedTreeControl } from "@angular/cdk/tree";
import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatTreeNestedDataSource } from "@angular/material/tree";
import { Router } from "@angular/router";
import { IconModel } from "src/app/shared/components/icon/model/icon.model";
import { MobileComponent } from "src/app/shared/components/mobile/interface/mobile.component";
import {
  HierarchyManagementService,
} from "src/app/shared/service/store-management/hierarchy-management/hierarchy-management.service";
import {
  ProfileManagementService,
} from "src/app/shared/service/store-management/profile-management/profile-management.service";
import { SubSink } from "subsink";

import { HierarchyNode } from "./model/hierarchy.model";
import { HierarchyService } from "./service/hierarchy.service";
import { MaterialModule } from "src/app/shared/module/material.module";
import { IconComponent } from "src/app/shared/components/icon/icon.component";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";

@Component({
    selector: "ald-hierarchy",
    templateUrl: "./hierarchy.component.html",
    styleUrls: ["./hierarchy.component.scss"],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule,
        IconComponent,
        I18nPipe
    ]
})
export class HierarchyComponent
  extends MobileComponent
  implements OnDestroy, OnInit {
  treeHierarchy: any[] = [];
  private workedHierarchy: HierarchyNode[] = [];
  private subs = new SubSink();
  treeForm: UntypedFormGroup;
  public treeControl = new NestedTreeControl<HierarchyNode>(
    (node) => node.children
  );

  public dataSource = new MatTreeNestedDataSource<HierarchyNode>();
  @ViewChild("outputDiv", { static: false })
  public outputDivRef: ElementRef<HTMLParagraphElement>;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private hierarchyService: HierarchyService,
    private hierarchyManagementService: HierarchyManagementService,
    private profileManagement: ProfileManagementService,
    public dialogRef: MatDialogRef<HierarchyComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.initHierarchy();
    this.loadForm();
    this.filterTreeValueChange();
  }

  loadForm(): void {
    this.treeForm = this.formBuilder.group({
      filterTree: [""],
    });
  }

  filterTreeValueChange(): void {
    this.valueChanges(this.treeForm, "filterTree").subscribe(
      (filterTreeValueChanged) => {
        this.filterChanged(filterTreeValueChanged);
      }
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  initHierarchy(): void {
    const hierarchySaved = this.hierarchyManagementService.getHierarchyStored();
    const profile = this.profileManagement.getProfileByStore()
    if (!!!hierarchySaved || profile.isSales) {
      this.getHierarchyFromService();
    } else {
      this.treeHierarchy =
        this.hierarchyManagementService.getHierarchySelectedForTree();
      this.getHierarchyFromStore(hierarchySaved);
      // this.selectAllNodes(this.workedHierarchy);
      // this.submit2();
    }
  }

  // selectAllNodes(nodes: HierarchyNode[]): void {
  //   nodes.forEach((node) => {
  //     node.selected = true; 
  //     if (node.children) {
  //       this.selectAllNodes(node.children); // mi metto a true tutti i figli del parent
  //     }
  //   });
  // }

  getHierarchyFromService(): void {
    this.subs.add(
      this.hierarchyService.getHierarchy().subscribe((hierarchyRes: any) => {
        const defineArrayForRecursion = [];
        defineArrayForRecursion.push(hierarchyRes.root);
        this.hierarchyManagementService.setHierarchyOnStore(
          defineArrayForRecursion
        );
        this.setDataSourceAndWokedHierarchy(defineArrayForRecursion);
      })
    );
  }

  getHierarchyFromStore(defineArrayForRecursion): void {
    this.setDataSourceAndWokedHierarchy(defineArrayForRecursion);
  }

  setDataSourceAndWokedHierarchy(defineArrayForRecursion): void {
    this.dataSource.data = defineArrayForRecursion;
    this.workedHierarchy = defineArrayForRecursion;


    Object.keys(this.dataSource.data).forEach((key) => {

      this.setParent(this.dataSource.data[key], null);
    });
    this.setDisplayHierarchy([]);
  }

  public hasChild = (_: number, node: HierarchyNode) =>
    !!node.children && node.children.length > 0

  private setParent(node: HierarchyNode, parent: HierarchyNode): void {
    this.checkedIfEqualsToUserCustomer(node);
    if (!!parent) {
      node.parent = parent;
      if (node.children) {
        node.children.forEach((childNode) => {
          this.setParent(childNode, node);
        });
      }
    }
  }

  checkedIfEqualsToUserCustomer(node: HierarchyNode): HierarchyNode {
    if (this.treeHierarchy.length === 0) {
      const profile = this.profileManagement.getProfileByStore();
      if (+profile.customerId === +node.id) {
        node.selected = true;
      }

    }
    return node;

  }


  private checkAllParents(node: HierarchyNode): void {
    if (node.parent) {
      const descendants = this.treeControl.getDescendants(node.parent);
      node.parent.selected = descendants.every((child) => child.selected);
      node.parent.indeterminate = descendants.some((child) => child.selected);
      this.checkAllParents(node.parent);
    }
  }

  todoItemSelectionToggle(checked, node): void {
    node.selected = checked;
    if (node.children) {
      node.children.forEach((x) => {
        this.todoItemSelectionToggle(checked, x);
      });
    }
    this.checkAllParents(node);

    const hierarchySelected = [];
    this.setDisplayHierarchy(hierarchySelected);
  }

  itemToggle(checked: boolean, node: HierarchyNode): void {
    node.selected = checked;

    if (node.children) {
      node.children.forEach((child) => {
        this.itemToggle(checked, child);
      });
    }

    this.checkAllParents(node);
  }

  submit(): void {
    const hierarchySelected = [];
    this.setDisplayHierarchy(hierarchySelected);
    this.hierarchyManagementService.setHierarchyOnStore(this.workedHierarchy);
    this.hierarchyManagementService.setHierarchyIdsSelected(
      hierarchySelected.map((res) => res.id)
    );
    this.hierarchyManagementService.setHierarchyRefsSelected(
      hierarchySelected.map((res) => res.idRef)
    );
    this.hierarchyManagementService.setHierarchyIdsSelectedWithName(
      hierarchySelected
    )
    this.dialogRef.close();
    this.router.navigate(["home"]);
  }

 isSubmitDisabled(): boolean {
  return this.treeHierarchy.filter(item => item.selected).length === 0;
}

  // submit2() {
  //   const hierarchySelected = [];
  //   this.setDisplayHierarchy(hierarchySelected);
  //   this.hierarchyManagementService.setHierarchyOnStore(this.workedHierarchy);
  //   this.hierarchyManagementService.setHierarchyIdsSelected(
  //     hierarchySelected.map((res) => res.id)
  //   );
  //   this.hierarchyManagementService.setHierarchyRefsSelected(
  //     hierarchySelected.map((res) => res.idRef)
  //   );

  // }

  setDisplayHierarchy(hierarchySelected): void {
    this.recursionAddElementTreeHierarchy(
      this.workedHierarchy,
      hierarchySelected
    );
    this.treeHierarchy = [...hierarchySelected];
    this.treeHierarchy = this.deleteDuplicateFromHierarchySelection();
    this.hierarchyManagementService.setHierarchySelectedForTree(
      this.treeHierarchy
    );

  }

  deleteDuplicateFromHierarchySelection(): any {
    return this.treeHierarchy.filter(
      (elem, index, self): boolean => index === self.indexOf(elem)
    );
  }

  clear(): void {
    if(this.isSubmitDisabled()===false){
      this.treeHierarchy = this.removeAllElementExceptCurrentCustomerId(this.treeHierarchy);
      this.hierarchyManagementService.setHierarchySelectedForTree(
        this.treeHierarchy
      );
      this.recursionDeselectElementTreeHierarchyExcludeUserCustomerId(this.workedHierarchy);
      this.hierarchyManagementService.setHierarchyOnStore(this.workedHierarchy);
      this.hierarchyManagementService.setHierarchyIdsSelected(
        this.treeHierarchy.map((res) => res.id)
      );
      this.hierarchyManagementService.setHierarchyRefsSelected(
        this.treeHierarchy.map((res) => res.idRef)
      );
      this.hierarchyManagementService.setHierarchyIdsSelectedWithName( this.treeHierarchy);
      this.setDisplayHierarchy(this.treeHierarchy);
    }
    
    if(this.isSubmitDisabled()){

      this.treeHierarchy=this.hierarchyManagementService.getHierarchyStored();
      this.treeHierarchy = this.removeAllElementExceptCurrentCustomerId(this.treeHierarchy);
      this.treeHierarchy[0].selected=true;
      this.hierarchyManagementService.setHierarchySelectedForTree(
        this.treeHierarchy
      );
      this.recursionDeselectElementTreeHierarchyExcludeUserCustomerId(this.workedHierarchy);
      this.hierarchyManagementService.setHierarchyOnStore( this.treeHierarchy);

      this.hierarchyManagementService.setHierarchyIdsSelected(
        this.treeHierarchy.map((res) => res.id)
      );
      this.hierarchyManagementService.setHierarchyRefsSelected(
        this.treeHierarchy.map((res) => res.idRef)
      );
      this.hierarchyManagementService.setHierarchyIdsSelectedWithName( this.treeHierarchy);
      this.setDisplayHierarchy(this.treeHierarchy);
      this.initHierarchy();
      this.loadForm();
      this.filterTreeValueChange();
    }
    
   // this.dialogRef.close();
   // this.router.navigate(["home"]);
  }

  removeAllElementExceptCurrentCustomerId(treeHierarchy): any {
    const profile = this.profileManagement.getProfileByStore();
    return treeHierarchy.filter(node => node.id === +profile.customerId);
  }

  recursionDeselectElementTreeHierarchyExcludeUserCustomerId(datasource: HierarchyNode[]): void {
    const iterator = datasource;
    iterator.forEach((node) => {
      const profile = this.profileManagement.getProfileByStore();
      if (+profile.customerId !== +node.id) {
        this.deselecetionNode(node);
      } else if (node.children?.length > 0) {
        this.recursionDeselectElementTreeHierarchy(node.children);
      }
    });
  }

  deselecetionNode(node): void {
    if (node.selected) {
      node.selected = false;
      if (node.children?.length > 0) {
        this.recursionDeselectElementTreeHierarchy(node.children);
      }
    } else if (node.children?.length > 0) {
      this.recursionDeselectElementTreeHierarchy(node.children);
    }
  }

  recursionDeselectElementTreeHierarchy(datasource: HierarchyNode[]): void {
    const iterator = datasource;
    iterator.forEach((node) => {
      if (node.selected) {
        node.selected = false;
        if (node.children?.length > 0) {
          this.recursionDeselectElementTreeHierarchy(node.children);
        }
      } else if (node.children?.length > 0) {
        this.recursionDeselectElementTreeHierarchy(node.children);
      }
    });
  }

  recursionAddElementTreeHierarchy(datasource: HierarchyNode[], result): void {
    const iterator = datasource;
    iterator.forEach((node) => {
      if (node.selected) {
        result.push(node);
        if (node.children?.length > 0) {
          this.recursionAddElementTreeHierarchy(node.children, result);
        }
      } else if (node.children?.length > 0) {
        this.recursionAddElementTreeHierarchy(node.children, result);
      }

    });
  }

  recursionSearchElementTreeHierarchy(
    datasource: HierarchyNode[],
    filteredNodeList: HierarchyNode[],
    filterText
  ): void {
    const iterator = datasource;
    iterator.forEach((node) => {
      if (this.checkNameCondition(node, filterText, filteredNodeList)) {
        filteredNodeList.push(node);
        if (node.children?.length > 0) {
          this.recursionSearchElementTreeHierarchy(
            node.children,
            filteredNodeList,
            filterText
          );
        }
      } else if (node.children?.length > 0) {
        this.recursionSearchElementTreeHierarchy(
          node.children,
          filteredNodeList,
          filterText
        );
      }
    });
  }

  checkNameCondition(
    node: HierarchyNode,
    filterText: string,
    filteredNodeList: HierarchyNode[]
  ): boolean {
    return (
      (node.name.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) >
        -1 &&
        !filteredNodeList.some((e) => e.name === node.parent?.name)) ||
      (node.idRef
        .toString()
        .toLocaleLowerCase()
        .indexOf(filterText.toLocaleLowerCase()) > -1 &&
        !filteredNodeList.some((e) => e.idRef === node.parent?.idRef))
    );
  }

  filterChanged(filterText: any): void {
    const filteredTreeData = [] as HierarchyNode[];
    if (filterText) {
      this.recursionSearchElementTreeHierarchy(
        this.workedHierarchy,
        filteredTreeData,
        filterText
      );
      this.dataSource.data = filteredTreeData;
    } else {
      this.dataSource.data = this.workedHierarchy;
    }
  }

  onClose(): void {
      this.dialogRef.close();
  }

  getResultToShow(el: HierarchyNode): string {
    return el.idRef + " - " + el.name;
  }

  setIconAttributeForRendering(): IconModel {
    let iconInput = {} as IconModel;
    iconInput = {
      isMatIcon: true,
      iconName: "search",
      color: "blue",
    };
    return iconInput;
  }
}
